fx.ns("shared.screens", class UpsellFirstScreen extends shared.screens.BaseUpsellScreen {
	constructor() {
		super();
		this.title = fx.text("");
	}

	create() 
    {
        if (this.data.creation.upsell_options.length == 0)
            this.data.event("no-upsell-available");
        else
        {
            this.loading(true);
            this.data.getOptions();
            super.create();
        }
	}

	onDataEvent(e) 
    {
		if (e.type == "options-loaded") 
        {
            this.loading(false);

            if (this.data.optionsChoices.length == 0)
                this.data.event("no-upsell-available");
            else
            {
                const pageOptions = this._getOptionByIndex(0);
                this.choices = this.buildChoicesFromOptions(pageOptions ? pageOptions.options : []);

                if (this.choices.length > 0)
                    this.build();

                this._updateNextButton();
            }
		}
	}

	onBack() {
		if (this.data)
			this.data.event("previous-step");
	}

	onReady() {
		this.data.selectedOptions = [];	// clean selected options
		super.onReady();
	}

});